import React, { Component } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { FormControl } from '../../../facturotopia';
import Validator from 'validatorjs';

class SucursalUpsertForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      id: ['required', 'min:2'],
      sucursal: ['string', 'min:2'],
      ciudad: ['string', 'min:2'],
      iva_fronterizo: ['required', 'min:2', 'in:NO,SI'],
      codigo_postal: ['required', 'min:5', 'max:5'],
    };
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      status: undefined,
      ...value,
    };

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      isValid: validator.passes(),
    });
  };

  render() {
    const { data = {} } = this.props;

    return (
      <Form autoComplete="off">
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Código sucursal"
              name="id"
              placeholder=""
              help=""
              autoFocus={true}
              rules={this.rules.id}
              value={data.id}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Sucursal"
              name="sucursal"
              help=""
              placeholder=""
              rules={this.rules.sucursal}
              value={data.sucursal}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Ciudad"
              name="ciudad"
              help=""
              placeholder=""
              rules={this.rules.ciudad}
              value={data.ciudad}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Iva Fronterizo"
              name="iva_fronterizo"
              help=""
              placeholder=""
              options={[
                { id: '', label: 'Selecciona una opción' },
                { id: 'NO', label: 'NO' },
                { id: 'SI', label: 'SI' },
              ]}
              rules={this.rules.iva_fronterizo}
              value={data.iva_fronterizo}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Código Postal"
              name="codigo_postal"
              help=""
              placeholder=""
              rules={this.rules.codigo_postal}
              value={data.codigo_postal}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        {this.props.children}
      </Form>
    );
  }
}

export default SucursalUpsertForm;
